<template>
  <div class="member senior">
    <common-title titleName="研力特权卡" :isAPPShow="true" />
    <div class="member__top" v-if="!(isMini)"></div>
    <div class="member__contain member__contain-senior">
      <div v-if="showSeniorBtn === 2" class="tools">
        <benefits :userInfo="userInfo" :benefits="seniorBenefits"></benefits>
        <study-tools :activeTab="activeTab" :userMemberInfo="userMemberInfo" :userInfo="userInfo" />
        <question-bank />
        <study-video :activeTab="activeTab" :userMemberInfo="userMemberInfo" :userInfo="userInfo" :productId="politics"
          :showDownAppModal="false" />
        <weekly :userMemberInfo="userMemberInfo" :weeklyInfo="weeklyInfo" />
        <study-server :activeTab="activeTab" :userMemberInfo="userMemberInfo" :userInfo="userInfo" :productId="server" />
        <course :activeTab="30" :userInfo="userInfo" :userMemberInfo="userMemberInfo" :productIds="course || []" />
        <coupons :activeTab="activeTab" v-if="couponIds.length" :couponIds="couponIds" :userInfo="userInfo"
          :userMemberInfo="userMemberInfo" />
        <buy-btn :userMemberInfo="userMemberInfo" :userInfo="userInfo" :activeTab="activeTab"
          :memberLevelInfo="memberLevelInfo" :generateOrder="generateOrder" :openChat="openChat"
          :showSeniorBtn="showSeniorBtn" :showBasicBtn="1" />
      </div>
      <div v-if="showSeniorBtn === 1">
        <div class="member__empty"></div>
        <div class="member__empty-desc">权益版块即将开放</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  getMemberLevelInfo, reqCombinationlist, reqCombinationDetail, reqSubOrder, getSeniorBenefits, getMemberDetail, getWeekly,
} from '@/api/member/index';
import wx from 'weixin-js-sdk';

import Benefits from './components/Benefits/index.vue';
import StudyTools from '../member/components/StudyTools/index.vue';
import QuestionBank from '../member/components/QuestionBank/index.vue';
import StudyVideo from '../member/components/StudyVideo/index.vue';
import Weekly from '../member/components/Weekly/index.vue';
import StudyServer from '../member/components/StudyServer/index.vue';
import Course from '../member/components/Courses/index.vue';
import Coupons from '../member/components/Coupons/index.vue';
import BuyBtn from '../member/components/BuyBtn/index.vue';

export default {
  components: {
    Benefits,
    StudyTools,
    QuestionBank,
    StudyVideo,
    Weekly,
    StudyServer,
    Course,
    Coupons,
    BuyBtn,
  },
  data() {
    return {
      gioVisitUserId: '',
      userMemberInfo: {
        level: 20, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: null,
        deadlineEndTime: null, // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      },
      activeTab: 30, // 20 基础会员 30 高级会员
      memberLevelInfo: {
        30: {
          packageId: null,
          products: null,
          priceInfo: {},
          productIds: [],
          faq: '', // 常见问题
          server: '', // 当前学习服务绑定ID
          allServer: '', // 学习服务绑定所有ID
          politics: '', // 当前时政绑定ID
          allPolitics: '', // 时政绑定绑定所有ID
          coupons: '', // 展示的优惠券
        }, // 高级会员
      },
      memberLevelInfoTemp: null,
      showSeniorBtn: 0,
      isApp: this.$root.$data.isApp || false,
      isMini: this.$root.miniprogram || false,
      basicBenefits: [],
      seniorBenefits: [],
      faq: '',
      isFaqShow: false,
      weeklyInfo: null,
      politics: '',
      server: '',
      course: '',
      couponIds: '',
    };
  },
  created() {
    this.init();
  },

  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = (value) => {
      this.getAndroid(value);
    };
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
      window['iqhApp2jsBridge.triggerSC'].reload = this.init;
    }, 100);
  },
  methods: {
    // mode不要删除 不然会报错
    async init(mode) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      this.memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfo));
      // 获得高级权益配置
      await this.reqSeniorBenefits();
      // 获取会员等级相关信息
      const MemberLevelInfo = await getMemberLevelInfo();
      let showSeniorBtn = 1;
      const allProductIds = MemberLevelInfo?.filter((item) => {
        if (item.memberLevel === 30) {
          this.memberLevelInfoTemp[item.memberLevel] = {
            packageId: item.packageId,
          };
          showSeniorBtn = 2;
        }
        return item.memberLevel === 30;
      }).map((item) => item.packageId);
      this.showSeniorBtn = showSeniorBtn;
      if (showSeniorBtn === 2) {
        // 获取展示的产品ID配置
        const memberDetail = await getMemberDetail();
        memberDetail.forEach((item) => {
          const { code, remark } = item;
          const {
            politics, allPolitics, server, allServer, coupons,
          } = JSON.parse(remark);
          this.memberLevelInfoTemp[code] = {
            ...this.memberLevelInfoTemp[code],
            politics,
            allPolitics,
            server,
            allServer,
            coupons,
          };
        });
        await this.setPriceInfo(allProductIds, 30);
        await this.setProductInfo(allProductIds);
        this.memberLevelInfo = this.memberLevelInfoTemp;
        this.setWeeklyInfo();
        this.setIds(30);
        this.$toast.clear();
      }
    },
    async setWeeklyInfo() {
      const data = await getWeekly();
      if (data) {
        this.weeklyInfo = data;
      }
    },
    // 获取高级权益
    async reqSeniorBenefits() {
      const data = await getSeniorBenefits();
      this.seniorBenefits = data.map((item) => {
        const { remark } = item;
        const { title, icon } = JSON.parse(remark);
        return { title, icon };
      });
    },
    setIds(key) {
      const { server, politics, coupons } = this.memberLevelInfo[key];
      this.server = server;
      this.politics = politics;
      this.course = this.memberLevelInfo[key].productIds.map(String).filter((item) => (item !== server && item !== politics));
      this.couponIds = coupons.split(',').map(String);
    },
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${this.$route.query.liveRoomId || ''}',wechatSource:'${this.miniParams()}'}`;
      }
    },
    // 获取价格信息
    async setPriceInfo(allProductIds, key) {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfoTemp));
      const data = await reqCombinationlist(endPoint, allProductIds);
      data.forEach((item) => {
        const {
          packageDiscountRespVO, originalPrice, sellPrice,
        } = item;
        const { payPrice, promotionLabel, promotionEndTime } = packageDiscountRespVO;
        const priceInfo = {
          price: promotionLabel ? payPrice : sellPrice,
          originalPrice: promotionLabel ? originalPrice : '',
          endTime: promotionEndTime,
        };
        memberLevelInfoTemp[key].priceInfo = priceInfo;
      });
      this.memberLevelInfoTemp = memberLevelInfoTemp;
    },
    // 获取产品详情
    async setProductInfo(allProductIds) {
      const memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfoTemp));
      const responses = await reqCombinationDetail(allProductIds[0]);
      const { packageId, packageProductRespList, faq } = responses;
      const orderDetailArr = packageProductRespList.map((subItem) => {
        const { packageProductSkuWebRespList, productId } = subItem;
        const { skuId } = packageProductSkuWebRespList[0];
        return {
          productId,
          skuId,
          packageId,
        };
      });
      memberLevelInfoTemp[30].products = orderDetailArr;
      memberLevelInfoTemp[30].faq = faq;
      memberLevelInfoTemp[30].productIds = orderDetailArr.map((item) => item.productId);
      this.memberLevelInfoTemp = memberLevelInfoTemp;
    },
    // 生成订单
    generateOrder(level) {
      if (!this.userInfo.id) {
        if (this.isApp) {
          this.$sendToApp('login', {}, true);
        } if (this.$root.miniprogram) {
          let url = window.location.href;
          const [domain, searchParams] = url.split('?');
          const params = searchParams.split('&');
          if (params) {
            const paramsMap = new Map();
            params.forEach((item) => {
              const [key, value] = item.split('=');
              if (key) {
                paramsMap.set(key, value);
              }
            });
            const entries = paramsMap.entries();
            let query = '';
            const ExcludequeryArr = ['THIRD_SESSION', 'env'];
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of entries) {
              if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
            url = `${domain}?${query}`;
          }
          const redirctUrl = encodeURIComponent(`/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`);
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        } else {
          const { path, query } = this.$route;
          this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        }
      } else {
        switch (level) {
          case 0:
            break;
          case 10:
            this.receiveTrialMember();
            break;
          default:
            this.entryPayOrder(level);
        }
      }
    },
    // 领取试用会员
    async receiveTrialMember() {
      let referer = '';
      if (sessionStorage.getItem('fromPageUrl')) {
        const paramData = JSON.parse(sessionStorage.getItem('fromPageUrl'));
        referer = paramData.fromPageUrl ? paramData.fromPageUrl : paramData.fromPageUrlLast;
      }
      // eslint-disable-next-line
      let uuid = gio('getVisitUserId') || [];
      // eslint-disable-next-line
      if (!this.isApp) {
        this.gioVisitUserId = `{u:'${uuid[0] || ''}', roomId: '${this.$route.query.liveRoomId || ''}',wechatSource:'会员中心'}`;
      }
      const { packageId, products } = this.memberLevelInfo[10];
      const subData = {
        // 订单提交请求对象
        channelMark: 5, // 下单渠道 ：5学员端下单
        products: products.map((item) => ({
          productId: item.productId,
          productSkuId: item.skuId,
          quantity: 1, // 产品数量
          type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
          packageId,
        })),
        terminalMark: this.$global.terminalMark,
        orderReferer: referer,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderUrl: window.location.href,
        extendParam: this.gioVisitUserId,
        orderSource: '会员中心',
      };
      try {
        await reqSubOrder(subData);
        this.$toast('会员领取成功，请稍后刷新试试吧');
        this.showTrialBtn = false;
      } catch (e) {
        console.log(e);
      }
    },
    // 支付订单
    entryPayOrder(level) {
      const info = this.memberLevelInfo[level];
      const { packageId, products } = info;
      if (this.isApp) {
        this.$sendToApp('buyCourseNew', {
          product: JSON.stringify(products), packageId, miniBeforePageName: 8, level,
        }, false);
      } else if (this.$root.miniprogram) {
        const url = window.location.href;
        const [, searchParams] = url.split('?');
        const { origin } = window.location;
        let path = `${origin}/ark/payOrder?product=${JSON.stringify(products)}&packageId=${packageId}&miniBeforePageName=8&`;
        const params = searchParams.split('&');
        if (params) {
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (ExcludequeryArr.includes(key) && value) query += `${key}=${value}&`;
          }
          path += query;
        }
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(path)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
      } else {
        const miniBeforePageName = localStorage.getItem('miniBeforePageName');
        if (!miniBeforePageName) {
          localStorage.setItem('miniBeforePageName', 8);
        }
        this.$router.push({
          path: '/payOrder',
          query: {
            product: JSON.stringify(products),
            packageId,
          },
        });
      }
    },
    openChat() {
      if (this.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: `https://iqihang.sobot.com/chat/h5/v2/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${this.userInfo.id || ''}`,
          },
          false,
        );
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: '/subPackages/zhichi/zhichi',
        });
      } else {
        window.open(
          `https://iqihang.sobot.com/chat/h5/v2/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${this.userInfo.id || ''}`,
        );
      }
    },
    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.init();
    },
    showFaq(key) {
      const { faq } = this.memberLevelInfo[key];
      this.faq = faq;
      this.isFaqShow = true;
    },
    closeFaq() {
      this.faq = '';
      this.isFaqShow = false;
    },
  },
};

</script>

<style scoped lang="scss">
@import '../member/index.scss';

.member {
  width: 750px;

  &__top {
    height: 100px;
  }

  &__tab {
    @include background(100%, 90px);
    display: flex;

    &-item {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .icon {
        @include background(43px, 43px);
        margin-right: 14px;
      }
    }

    &-basic .icon {
      @include backgroundImage('tab_basic_icon.png');
    }

    &-senior .icon {
      @include backgroundImage('tab_basic_senior.png');
    }

    &.basic {
      @include backgroundImage('tab_basic.png');
    }

    &.senior {
      @include backgroundImage('tab_senior.png');
    }

    &_title {
      font-size: 31px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #FFE2C4;
    }
  }

  &__contain {

    &-basic {
      background: #9C6A3E;
    }

    &-senior {
      background: #100F17;
    }
  }

  .tools {
    width: 750px;
    padding-bottom: 170px;
    background: #F7F8FC;

    .member__empty {
      @include background(308px, 219px);
      @include backgroundImage('member_empty.png');
      margin: 100px auto 13px;

      &-desc {
        font-size: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 36px;
        text-align: center;
      }
    }
  }
}

.btn {
  width: 350px;
  height: 71px;
  margin: 0 auto 40px;
  color: #FFF;
  font-weight: 500;
  font-size: 29px;
  line-height: 71px;
  text-align: center;
  background: linear-gradient(270deg, #FF6C02 0%, #FF7F41 100%);
  border-radius: 35px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .7);
  z-index: 10;

  .modal_contain {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #FFFFFF;
    border-radius: 14px;
    width: 634px;
    padding: 31px 33px 58px;

    .title_top {
      display: flex;
      justify-content: space-between;
      height: 40px;
      align-items: center;
    }

    .modal_title {
      font-size: 29px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
    }

    .modal_close {
      @include background(29px, 29px);
      @include backgroundImage('member_close.png')
    }

    .modal_faq {
      margin-top: 72px;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 43px;
    }
  }
}
</style>
